import { Reveal } from "./Reveal";
import { FButton } from "./FButton";
import { TrustStrip } from "./TrustStrip";
import { ArrowRight } from "lucide-react";
import { BRAND } from "@/data/content";

/**
 * CTASection — reusable closing call-to-action band.
 */
export const CTASection = ({
  title = "Ready to turn your audience into income?",
  body = BRAND.promise,
  primaryLabel = "Apply to FanFuel",
  primaryTo = "/apply",
  secondaryLabel = "See how it works",
  secondaryTo = "/how-it-works",
  showTrust = true,
}) => (
  <section className="relative overflow-hidden px-6 py-24 md:py-32" data-testid="cta-section">
    <div className="ff-radial-glow absolute inset-x-0 top-0 h-full" />
    <Reveal className="relative mx-auto max-w-4xl rounded-3xl border border-white/10 bg-ff-slate/70 p-10 backdrop-blur-xl md:p-16">
      <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-ff-ivory md:text-5xl text-balance">
        {title}
      </h2>
      <p className="mt-5 max-w-2xl text-base leading-relaxed text-ff-grey md:text-lg">{body}</p>
      <div className="mt-9 flex flex-col gap-3 sm:flex-row">
        <FButton to={primaryTo} data-testid="cta-primary-btn">
          {primaryLabel} <ArrowRight className="h-4 w-4" />
        </FButton>
        {secondaryLabel && (
          <FButton variant="secondary" to={secondaryTo} data-testid="cta-secondary-btn">
            {secondaryLabel}
          </FButton>
        )}
      </div>
      {showTrust && <TrustStrip className="mt-9" />}
    </Reveal>
  </section>
);

export default CTASection;
